/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Add_Contract_Term_MonthsInputs */



/**
* | output |
* | --- |
* | "{count} months" |
*
* @param {Partner_Add_Contract_Term_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_term_months = /** @type {((inputs: Partner_Add_Contract_Term_MonthsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Term_MonthsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Monate`)
	return /** @type {LocalizedString} */ (`${i?.count} months`)
});